module.exports = __webpack_public_path__ + "media/images/projects/12-logo-34cdc44c32f71136d805b646406b0c48.png";